import React from 'react';
import { useSearchParams } from 'react-router-dom';

import ApplicationsTable from '../Components/TablesForUsersPage/ApplicationsTable';
import AllUsersTable from '../Components/TablesForUsersPage/AllUsersTable';
import ArbitrationManagersTable from '../Components/TablesForUsersPage/ArbitrationManagersTable';
import DeactivatedAccountsTable from '../Components/TablesForUsersPage/DeactivatedAccountsTable';
import SearchUsers from '../Components/SearchUsers';

import HeaderPanel from '../Components/HeaderPanel';

import styles from '../styles/TableContainers.module.css';
import headerPanel from '../styles/HeaderPanel.module.css';
import subpageSelection from '../styles/SubpageSelection.module.css';

const Users = () => {
    const [isSearch, setIsSearch] = React.useState(false);
    const [searchParams, setSearchParams] = useSearchParams();
    const table = searchParams.get('table') || 'applications';

    return (
    <>
        {isSearch && <SearchUsers closeModal={() => {setIsSearch(false)}} type={''} />}

        <div className='mainContainer'>
            <h1>Пользователи</h1>
            <HeaderPanel typePanel='Назад' />
            <div className={headerPanel.additionalPanel}>
                <div className={headerPanel.searchBtn} onClick={(e) => {e.preventDefault(); setIsSearch(true)}}>Поиск по пользователям...</div>
            </div>
            <div className={subpageSelection.panel}>
                <a onClick={() => setSearchParams({ table: 'applications' })} className={`${subpageSelection.buttonToSubPages} ${table === 'applications' ? subpageSelection.active : ''}`}>Заявки</a>
                <a onClick={() => setSearchParams({ table: 'all-users' })} className={`${subpageSelection.buttonToSubPages} ${table === 'all-users' ? subpageSelection.active : ''}`}>Все пользователи</a>
                <a onClick={() => setSearchParams({ table: 'arbitration-managers' })} className={`${subpageSelection.buttonToSubPages} ${table === 'arbitration-managers' ? subpageSelection.active : ''}`}>Регионы и арбитражные управляющие</a>
                <a onClick={() => setSearchParams({ table: 'deactivated-accounts' })} className={`${subpageSelection.buttonToSubPages} ${table === 'deactivated-accounts' ? subpageSelection.active : ''}`}>Деактивированные</a>
            </div>
            {table == 'applications' ? <ApplicationsTable />
            : table == 'all-users' ? <AllUsersTable />
            : table == 'arbitration-managers'? <ArbitrationManagersTable />
            : table == 'deactivated-accounts'? <DeactivatedAccountsTable />
            : <a className={styles.initialState}>Выберите страницу</a>}
        </div>
    </>
    )
}

export default Users;